export const SHOW_PDF_VIEWER_MODAL_EVENT = "show-pdf-viewer-modal-event";
export const SHOW_SIGN_MODAL_EVENT = "show-sign-modal-event";

export const PAYROLL_SIGNED_EVENT = "payroll-signed-event";
